module.exports = __webpack_public_path__ + "static/media/W06F0001.3931b12d.svg";